import type {ListModuleConfig} from "~/domainModels/listView/listModuleConfig";
import type {
    TableRowActionsMenuItem,
    TableRowActionsToolbarItem,
} from "~/components/table/tableRowActions.types";

export function resolveEventContainerRowEngagementCapabilities({
    listConfig,
    showDisposition,
    showNotes,
    includeCreateDrawer,
    listCreateDrawerItemsCount,
    hasScheduleAction,
    hasLogCallAction,
    isArchiveAvailable,
    isArchivedView,
    isInQueueView,
}: {
    listConfig: ListModuleConfig | null;
    showDisposition: boolean;
    showNotes: boolean;
    includeCreateDrawer: boolean;
    listCreateDrawerItemsCount: number;
    hasScheduleAction: boolean;
    hasLogCallAction: boolean;
    isArchiveAvailable: boolean;
    isArchivedView: boolean;
    isInQueueView: boolean;
}): {
    toolbar: TableRowActionsToolbarItem[];
    moreMenu: TableRowActionsMenuItem[];
} {
    if (isArchivedView === true) {
        return {
            toolbar: ["view"],
            moreMenu: [],
        };
    }

    if (isInQueueView === true) {
        return {
            toolbar: ["edit", "view"],
            moreMenu: [],
        };
    }

    const toolbar: TableRowActionsToolbarItem[] = ["profile"];
    if (showDisposition === true) {
        toolbar.push("disposition");
    }
    toolbar.push("edit", "more");

    const moreMenu: TableRowActionsMenuItem[] = ["view"];
    if (hasLogCallAction === true) {
        moreMenu.push("logCall");
    } else if (includeCreateDrawer === true && listCreateDrawerItemsCount > 0) {
        moreMenu.push("create");
    }
    if (showNotes === true && listConfig?.showFooter === true) {
        moreMenu.push("notes");
    }
    if (hasScheduleAction === true) {
        moreMenu.push("scheduleCall");
    }
    if (isArchiveAvailable === true) {
        moreMenu.push("archive");
    }

    return {toolbar, moreMenu};
}
